export default {
  title: {
    en: 'Before you go...',
  },
  text: {
    en: 'We are so sorry to see you go...',
  },
  changeFrequencyText: {
    en: 'Getting too many perfumes?',
  },
  changeFrequencyButton: {
    en: 'Change frequency',
  },
  skipAMonthText: {
    en: 'Need a break?',
  },
  skipAMonthButton: {
    en: 'Skip a month',
  },
}
